import { DEFAULT_TEXT, DEFAULT_CURRENCY_TEXT } from "@/plugins/filters/constants";
import { isEmpty, numberFormatter, createMoment } from "@/helpers";
import moment from 'moment-timezone';

const filters = {
  formatCurrency: (val) => {
    if(isEmpty(val)) return DEFAULT_CURRENCY_TEXT;
    return numberFormatter.format(val);
  },
  formatKind: (val) => {
    let map = {voip:'VoIP',telco:'Telco',website:'Website'}
    return map[val];
  },
  formatCustom: (val, format) => {
    if(isEmpty(val)) return DEFAULT_TEXT;
    return format;
  },
  formatDate(val, format) {
    if(isEmpty(val)) return DEFAULT_TEXT;
    return createMoment(val).format(format || 'YYYY-MM-DD HH:mm A Z');
  },
  formatDateWithoutTime(val, format) {
    if(isEmpty(val)) return DEFAULT_TEXT;
    return createMoment(val).format(format || 'YYYY-MM-DD');
  },
  formatCustomDate(val, format) {
    if(isEmpty(val)) return DEFAULT_TEXT;
    const date = new Date(val);
    return moment(date).format(format);
  },
  customPlaceholder: (val, PLACEHOLDER) => {
    if(isEmpty(val)) return PLACEHOLDER || DEFAULT_TEXT;
    return val;
  },
  capitalizeString: (val) => {
    if(!val) return val;
    return val.toLowerCase().split(" ").map(e=>e.charAt(0).toUpperCase()+e.slice(1)).join(" ");
  },

  formatPrice: (val) => {
    if (val) { 
      return `£${parseFloat(val).toFixed(2)}`; 
    }

    return '£0.00';
  }
}

export default {
  install(Vue) {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key]);
    });
  }
}
